import React, { FC } from "react"
import Image from "next/image"

type Props = {
  icon: string
  heading: string
  sub_heading: string
  ratio: number
}

export const DetailsCard: FC<Props> = ({
  icon,
  heading,
  sub_heading,
  ratio,
}) => {
  return (
    <div className="col-span-1 dark:bg-primary-1 bg-white dark:bg-opacity-60 bg-opacity-70 border-2 dark:border-secondary-11 border-gray-300 rounded-xl pl-5 lg:pr-20 pr-6 lg:py-12 py-8">
      <div className="flex gap-x-4 items-center">
        <div className="dark:bg-secondary-13 rounded-full p-2 h-10 w-10 flex justify-center items-center">
          <Image
            className="w-4"
            src={icon}
            width={100}
            height={100}
            alt="icon"
          />
        </div>
        <div className="">
          <h1 className="dark:text-primary-10 text-gray-500 2xl:text-22 text-lg">
            {heading}
          </h1>
          <p className="dark:text-primary-8 text-light-1 pt-2 text-sm">
            {sub_heading} <br />
          </p>
        </div>
      </div>
    </div>
  )
}
